// components/BestSellingProducts.jsx
import React from "react";
import { FiLayers } from "react-icons/fi";

const BestSellingProducts = ({ products }) => {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-bold text-gray-900">
          Best Selling Products
        </h3>
        <FiLayers size={24} className="text-gray-400" />
      </div>
      <div className="space-y-4">
        {products.map((product, index) => (
          <div
            key={product._id}
            className="flex items-center justify-between py-3 border-b border-gray-100 last:border-0"
          >
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 rounded-full bg-gray-900 text-white flex items-center justify-center text-sm font-bold">
                {index + 1}
              </div>
              <span className="text-gray-700 font-medium">{product.name}</span>
            </div>
            <span className="text-gray-900 font-bold">
              {product.salesCount} sales
            </span>
          </div>
        ))}
        {products.length === 0 && (
          <p className="text-center text-gray-400 py-4">
            No sales data available
          </p>
        )}
      </div>
    </div>
  );
};

export default BestSellingProducts;
